
import { TimelineMax,TweenMax,Sine} from "gsap";
// import gsap from 'gsap';
// TimelineMax, Power2, Elastic, CSSPlugin ,Tweenmax TweenMax, Sine


export function play(){

  TweenMax.to(`[data-name="水位計（上下移動）"] `,3,{
    y: -30,
    ease: Sine.easeInOut
  }).repeat(-1).yoyo(true)

  // let tl = new TimelineMax()
  // tl.staggerFrom(`[data-name="水位計（上下移動）"] line, [data-name="水位計（上下移動）"] polygon `,0.7,{
  //   opacity: 0
  // },0.1).repeat(-1)


  TweenMax.to(`[data-name="智慧水情（數據跑動）"] `,2,{
    y: -30,
    ease: Sine.easeInOut
  }).repeat(-1).yoyo(true)

  TweenMax.set(`[data-name="智慧水情（數據跑動）"] line, [data-name="智慧水情（數據跑動）"] polygon `,{
    opacity: 1
  })

  TweenMax.staggerFrom(`[data-name="智慧水情（數據跑動）"] line, [data-name="智慧水情（數據跑動）"] polygon `,1,{
    opacity: 0
  },0.2).repeat(-1)
  
  //水管

  TweenMax.to(`[data-name="buildings_水管01"]`,2,{
    scale: 1.05,
    x: 3,
    ease: Sine.easeInOut
  }).repeat(-1).yoyo(true)

  TweenMax.set(`[data-name="buildings_水管02"]`,{
    transformOrigin: '50% 0% 0%'
  })

  TweenMax.to(`[data-name="buildings_水管02"]`,1.5,{
    scale: 1.05,
    y: 5,
    ease: Sine.easeInOut
  }).repeat(-1).yoyo(true)

  TweenMax.to(`[data-name="buildings_水管03"]`,2,{
    scale: 1.07,
    y: 5,
    ease: Sine.easeInOut
  }).delay(0.5).repeat(-1).yoyo(true)

  // gsap
  TweenMax.set(`[data-name="water_pattern"] path`,{
    css: {
      "stroke-dasharray": 100,
    }
  })
  TweenMax.staggerFrom(`[data-name="water_pattern"] path`,5,{
    css: {
      "stroke-dashoffset": 1000
    }
  },0.1).repeat(-1)
  
  // gsap.from(, {duration:1,stagger: 0.1, drawSVG: 0});

}
